import React from 'react';
import PageSeo from '@/seo/PageSeo';
import ApplyAcademic from '../components/SignUp/ApplyAcademicPage';

function ApplyAcademicPage() {
  return (
    <React.Fragment>
      <PageSeo
        title="Academic Access to the Gene-Disease Database | DISGENET"
        description="Apply for academic access to DISGENET, the curated gene-disease association database used by researchers in genomics and drug discovery."
        path="/academic-apply"
      />
      <ApplyAcademic />
    </React.Fragment>
  );
}

export default ApplyAcademicPage;
